const configTiposCompromisso = {

  peticionar: {
    label: "Peticionar",
    campos: [
      { name: "colaboradorExecutor", label: "Executor da tarefa", tipo: "text"},
      { name: "colaboradorPrazoExecutar", label: "Realizar tarefa", tipo: "date"},
      { name: "nomeParte", label: "Nome da parte", tipo: "text" },
      { name: "areaAcao", label: "Área da ação", tipo: "text" },
      { name: "dataPrazo", label: "Data", tipo: "date" }
    ]
  },

  emendar: {
    label: "Emendar",
    campos: [
      { name: "colaboradorExecutor", label: "Executor da tarefa", tipo: "text"},
      { name: "colaboradorPrazoExecutar", label: "Realizar tarefa", tipo: "date"},
      { name: "processoId", label: "Processo", tipo: "processo" },
      { name: "dataPrazo", label: "Data final", tipo: "date" }
    ]
  },

  manifestar: {
    label: "Manifestar",
    campos: [
      { name: "colaboradorExecutor", label: "Executor da tarefa", tipo: "text"},
      { name: "colaboradorPrazoExecutar", label: "Realizar tarefa", tipo: "date"},
      { name: "processoId", label: "Processo", tipo: "processo" },
      { name: "dataPrazo", label: "Data final", tipo: "date" }
    ]
  },

  recorrer: {
    label: "Recorrer",
    campos: [
      { name: "colaboradorExecutor", label: "Executor da tarefa", tipo: "text"},
      { name: "colaboradorPrazoExecutar", label: "Realizar tarefa", tipo: "date"},
      { name: "processoId", label: "Processo", tipo: "processo" },
      { name: "dataPrazo", label: "Data final", tipo: "date" }
    ]
  },

  executar: {
    label: "Executar",
    campos: [
      { name: "colaboradorExecutor", label: "Executor da tarefa", tipo: "text"},
      { name: "colaboradorPrazoExecutar", label: "Realizar tarefa", tipo: "date"},
      { name: "processoId", label: "Processo", tipo: "processo" },
      { name: "dataPrazo", label: "Data final", tipo: "date" }
    ]
  },

  audiencia: {
    label: "Audiência",
    campos: [
      { name: "colaboradorExecutor", label: "Executor da tarefa", tipo: "text"},
      { name: "colaboradorPrazoExecutar", label: "Realizar tarefa", tipo: "date"},
      { name: "processoId", label: "Processo", tipo: "processo" },
      { name: "dataPrazo", label: "Data da audiência", tipo: "date" }
    ]
  },

  sustentacao: {
      label:"Sustentação oral",
      campos:[
        { name: "colaboradorExecutor", label: "Executor da tarefa", tipo: "text"},
        { name: "colaboradorPrazoExecutar", label: "Realizar tarefa", tipo: "date"},
        { name:"processoId", label:"Processo", tipo:"processo"},
        { name:"dataPrazo", label:"Data da sessão", tipo:"date"}
      ]
  },

  outros: {
    label:"Outros",
    campos:[
      { name: "colaboradorExecutor", label: "Executor", tipo: "text"},
      { name: "colaboradorPrazoExecutar", label: "Realizar tarefa", tipo: "date"},
    ]
  }
}
export default configTiposCompromisso